<template>
  <div class="dialog-container dialog-light">
    <div class="dialog dialog-md">
      <ax-dialog-header text="Business Information" :type="'details'"></ax-dialog-header>
      <div class="dialog-body">
        <div class="business-info-form">
          <div class="form-group">
            <k-input id="business-industry"
                     type="text"
                     class=""
                     v-model="industry.businessIndustryName"
                     :label="'Your business industry'"
                     placeholder="Your business industry"
                     :readonly="true"
                     :disabled="true" />
          </div>
          <div class="form-group">
            <k-input id="business-name"
                     type="text"
                     class=""
                     v-model="name"
                     :label="'Business name*'"
                     placeholder="Business Name"
                     ref="businessNameInput"
                     v-kendo-validator="validateBusinessName()" />
          </div>
          <div class="form-group mt-4">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex">
                    <k-checkbox
                      label="Business is GST Exempt"              
                      v-model="gstExclusive"        
                      size="large"
                      class="white-checkbox"
                      :disabled="true"
                    />
                    <PromptIcon content="If enabled, your cost of goods sold, and other revenue will not have GST applied." />
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <div class="d-flex">
                    <k-checkbox
                      label="Other Income has GST"
                      :disabled="true"
                      v-model="otherIncomeHasGst"
                      size="large"
                      class="white-checkbox"
                    />
                    <PromptIcon content="If enabled, your other income will have GST applied." />
                  </div>
                </div>
              </div>
            </div>
		      <div v-show="false">
            <h3 class="mt-5">Year structure</h3>
            <div class="row form-group mb-4 p1">
              <div class="col-6">
                <k-radio
                    :name="'financialYearStructure'"
                    :value="1"
                    :checked="yearStructureID===1"
                    @change="handleFinancialStructureChange"
                    :label="'Financial Year'"
                    :disabled="true"
                    tabindex="-1"
                    aria-disabled="true"
                    class="pe-none opacity-50"
                />
              </div>
              <div class="col-6">
                <k-radio
                    :name="'calendarYearStructure'"
                    :value="2"
                    :checked="yearStructureID===2"
                    @change="handleFinancialStructureChange"
                    :label="'Calendar'"
                    :disabled="true"
                    tabindex="-1"
                    aria-disabled="true"
                    class="pe-none opacity-50"
                />
              </div>
            </div>
          </div>
          <div class="mt-5">
          <h3>Primary contact</h3>
          <div class="form-group p-1" v-for="user in this.businessUsers" :key="user.userID">
            <k-radio
                :name="'primaryContact'"
                :value="user.userID"
                :checked="primaryContactID===user.userID"
                @change="handlePrimaryContactChange"
                :label="user.firstName + ' ' + user.lastName"
                :disabled="isEmployee"
            />
          </div>
          </div>
          <div class="mt-5">
          <k-button class="btn btn-lg btn-secondary w-100 save mb-2" type="button" @click="save">Save</k-button>
          <k-button class="btn btn-lg btn-outline-primary w-100" type="button" @click="$emit('closePopup')">Cancel</k-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from "../../store/index";
  import BusinessService from "../../services/business-service";
  import kendo from "@progress/kendo-ui";
  import { useToast } from "vue-toastification";
  import PromptIcon from "@/components/PromptIcon";
  const toast = useToast();

  export default {
    components: {
      PromptIcon,
    },
    name: "business-info-dialog",
    async beforeCreate() {
      await store.dispatch("loadBusinessIndustries");
      await store.dispatch("initialise");
    },
    data() {
      return {
        industry: "",
        name: "",
        yearStructureID: 1,
        primaryContactID: null,
        industryID: 0,
        businessID: 0,
        businessUsers: [],
        currentMonth: null,
        invalidBusinessName: false,
        tooltipText: 'If enabled, your cost of goods sold, and other revenue will not have GST applied.',
        gstExclusive: false,
        originalGstExclusiveValue : false,
        startMonth: null,
        otherIncomeHasGst: false,
        originalOtherIncomeHasGst: false,
      }
    },
    computed: {
      anyInvalid: function () {
        return this.invalidBusinessName || !this.primaryContactID;
      },
      isEmployee() {
        return !store.getters.isAdmin && !store.getters.isOwner;
      }
    },
    mounted() {
      this.getBusinessInfo();
    },
    methods: {
        handleFinancialStructureChange: function(e) {
            this.yearStructureID = e.value;
        },
        handlePrimaryContactChange: function(e) {
            this.primaryContactID = e.value;
        },
        getBusinessInfo() {
          if (store.getters.isSubscriptionLocked || !store.getters.businessID) {
            return;
          }
          BusinessService.getBusinessDetails()
            .then((response) => {
              this.industry = store.getters.industries.find(industry => industry.businessIndustryID === response.businessDetails.businessIndustryID);
              this.name = response.businessDetails.businessName;
              this.yearStructureID = response.businessDetails.businessYearStructureID;
              this.industryID = response.businessDetails.businessIndustryID;
              this.businessID = response.businessDetails.businessID;
              this.primaryContactID = response.businessDetails.primaryContactID;
              this.currentMonth = response.businessDetails.currentMonth;
              this.gstExclusive = response.businessDetails.gstExclusive;
              this.originalGstExclusiveValue = response.businessDetails.gstExclusive;
              this.startMonth = response.businessDetails.startMonth;
              this.otherIncomeHasGst = response.businessDetails.otherIncomeHasGST;
              this.originalOtherIncomeHasGst = response.businessDetails.otherIncomeHasGST;
            }).catch(this.showAlert);

          BusinessService.getUsersInBusiness(false)
            .then((response) => {
              this.businessUsers = response.users;
            });
        },
        async save() {
          if (!this.anyInvalid) {
            await BusinessService.saveBusinessDetails({
              businessID: this.businessID,
              businessName: this.name.trim(),
              businessIndustryID: this.industryID,
              businessYearStructureID: this.yearStructureID,
              currentMonth: this.currentMonth,
              gstExclusive: this.gstExclusive,
              startMonth: this.startMonth,
              otherIncomeHasGst: this.otherIncomeHasGst,
            }, this.primaryContactID)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .then(() => {
              toast.clear();
              this.showSuccess("Business information updated.");
              this.$emit("closePopup");
              if ((this.originalGstExclusiveValue !== this.gstExclusive || this.originalOtherIncomeHasGst !== this.otherIncomeHasGst) &&
                  (location.href.includes("cashSummary") || location.href.includes("profitLoss") || location.href.includes("whatIf"))) {
                setTimeout(() => {
                  this.$router.go();
                }, 1000);
              }
            }).catch(this.showAlert);
          }
          else {
            const controlsToValidate = [
              this.$refs.businessNameInput.$el
            ];
            controlsToValidate.forEach(function(control) {
              const validator = kendo.jQuery(control).getKendoValidator();
              validator.validateInput(kendo.jQuery(control)[0].children[0]);
            });
          }
        },
        showAlert(error) {
          toast.clear();
          toast.error(error.message);
        },
        showSuccess(msg) {
          toast.clear();
          toast.success(msg);
        },          
        validateBusinessName: function () {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const vm = this;
          return {
            rules: {
              invalid: function (input) {
                if (input.val().trim() !== "") {
                  vm.invalidBusinessName = false;
                  return true;
                }
                vm.invalidBusinessName = true;
                return false;
              },
              required: function (input) {
                  if (input.val() === "") {
                      vm.invalidBusinessName = true;
                      return false;
                  }
                  vm.invalidBusinessName = false;
                  return true;
                }
              },
              messages: {
                invalid: "Invalid",
                required: "Required"
            }
          }
        }
    }
  }
</script>

<style lang="scss" restr>
</style>
